import axios from 'axios'
import { useAuthStore } from '../stores/auth'

const excelApi = axios.create({
  baseURL: import.meta.env.VITE_EXCEL_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

excelApi.interceptors.request.use(
  async (config) => {
    const authStore = useAuthStore()
    if (authStore.keycloak?.keycloak) {
      try {
        await authStore.keycloak.keycloak.updateToken(70)
      } catch (error) {
        console.error('Token refresh failed:', error)
      }
    }
    if (authStore.keycloak?.token) {
      config.headers.Authorization = `Bearer ${authStore.keycloak.token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default excelApi
